function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "CenterLogo_svg__a",
  x: 0,
  y: 0,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 88"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#CenterLogo_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 89",
  cx: 47.5,
  cy: 47.5,
  r: 47.5,
  transform: "translate(9 6)",
  fill: "#e8f6f4"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3",
  transform: "translate(34.722 39.906)",
  fill: "#00a68d"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 1",
  cx: 3.721,
  cy: 4.004,
  rx: 3.721,
  ry: 4.004,
  transform: "translate(2.976 20.119)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M2.214 30.43A3.946 3.946 0 000 34.043v3.066h8.167v-3.144a9.3 9.3 0 011.143-4.468 11.8 11.8 0 00-2.051-.2 11.855 11.855 0 00-5.045 1.133z"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 2",
  cx: 3.721,
  cy: 4.004,
  rx: 3.721,
  ry: 4.004,
  transform: "translate(32.741 20.119)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M41.341 30.43a11.522 11.522 0 00-7.1-.938 9.3 9.3 0 011.143 4.473v3.145h8.171v-3.067a3.946 3.946 0 00-2.214-3.613z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5",
  d: "M29.472 28.614a17.824 17.824 0 00-7.695-1.758 18.11 18.11 0 00-7.695 1.758 5.877 5.877 0 00-3.193 5.351v3.141h21.778v-3.141a5.877 5.877 0 00-3.195-5.351z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6",
  d: "M16.333 19.531a5.656 5.656 0 005.444 5.859 5.656 5.656 0 005.444-5.859 5.656 5.656 0 00-5.444-5.859 5.656 5.656 0 00-5.444 5.859z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 7",
  d: "M4.5 17.3a12.325 12.325 0 01-.871-4.414c0-5.039 3.666-8.985 8.348-8.985 4.864 0 6.933 3.4 9.8 7.012 2.849-3.574 4.9-7.012 9.8-7.012 4.682 0 8.348 3.945 8.348 8.985a12.325 12.325 0 01-.871 4.414 6.558 6.558 0 012.777 2.813 17 17 0 001.724-7.227C43.555 5.664 38.292 0 31.577 0a12.666 12.666 0 00-9.8 4.9 12.666 12.666 0 00-9.8-4.9C5.263 0 0 5.664 0 12.891a16.759 16.759 0 001.742 7.227A6.618 6.618 0 014.5 17.3z"
})));
var SvgCenterLogo = function SvgCenterLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 113 113"
  }, props), _ref, _ref2);
};
export default SvgCenterLogo;